import { snakeToCamel } from '../CaseUtils';

export const ActiveDriversETL = (list) => list?.map(snakeToCamel);

export const SelectedDriverETL = (json) => snakeToCamel(json);
